import React from "react"
import Slideshow from "../SlideShow/Slideshow"
import { useStaticQuery, graphql, Link } from "gatsby"

const GridA = () => {
  const data = useStaticQuery(graphql`
    {
      slides: allMasonContentCreative(
        filter: { meta: { contentType: { eq: "slide" } } }
        sort: { fields: updated_time, order: ASC}
      ) {
        nodes {
          url
          meta {
            position
            url
            order
          }
        }
        distinct(field: meta___order)
      }
      products: allMasonContentCreative(
        filter: { meta: { contentType: { eq: "featured_shoes" } } }
        sort: { fields: updated_time, order: ASC}
      ) {
        nodes {
          url
          meta {
            position
            url
            order
          }
        }
        distinct(field: meta___order)
      }
    }
  `)
  // const products = useStaticQuery(graphql`
  //   {

  //   }
  // `)
  return (
    <div className="grid-layout-wrap grid-a-wrap grid grid-cols-4 grid-rows-2 gap-4 mt-4">
      {data.products.distinct.map(position => {
        let card = data.products.nodes.filter((elem)=>elem.meta.order===position)[0]
        return (
          <div className="grid-img-wrap small-grid-card">
            <a
              target="_blank"
              href={card.meta.url !== null ? card.meta.url : "/"}
            >
              <img
                className="w-full h-full object-cover"
                src={card.url}
                alt="product image"
              />
            </a>
          </div>
        )
      })}
      <div className="relative grid-img-wrap big-grid-card">
        <Slideshow data={data.slides} />
      </div>
    </div>
  )
}

export default GridA
